import Page from 'modules/Page';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import { i18n } from 'i18n';
import * as constants from './constants';
import { StopeNoteApprovalPageParams } from './constants';
import useStopeNoteApprovalPageQueries, { StopeNoteApprovalPageQueries } from './useStopeNoteApprovalPageQueries';

const StopeNoteApprovalPage = lazyWithSuspense(() => import('./StopeNoteApprovalPage'));

const page: Page<StopeNoteApprovalPageParams> = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  admin: false,
  component: makePage<StopeNoteApprovalPageParams, StopeNoteApprovalPageQueries>({
    pageDataHook: useStopeNoteApprovalPageQueries,
    WrappedPage: StopeNoteApprovalPage,
    titleFn: () => i18n._(constants.TITLE),
  }),
};

export default page;
